/**
 * Pure display helpers for Lightweight Diagram UI (no generator logic).
 */

const CONFIDENCE_RANK = { strong: 0, inferred: 1, weak: 2, unknown: 3 };

export function confidenceRank(confidence) {
  return CONFIDENCE_RANK[(confidence || "unknown").toLowerCase()] ?? 3;
}

export function sortByConfidence(items, getConfidence = (item) => item.confidence) {
  return [...items].sort(
    (a, b) => confidenceRank(getConfidence(a)) - confidenceRank(getConfidence(b))
  );
}

/** Prefer readable short label; full path/reason belong in title tooltips. */
export function displayChipLabel(label, filePath) {
  const trimmed = (label || "").trim();
  if (!filePath) return trimmed || "?";
  const base = filePath.split("/").pop() || filePath;
  if (!trimmed || trimmed === base) return base;
  if (trimmed.length <= 24) return trimmed;
  const parts = filePath.split("/");
  if (parts.length >= 2) {
    return parts.slice(-2).join("/");
  }
  return trimmed.length > 28 ? `${trimmed.slice(0, 26)}…` : trimmed;
}

export function shortenReason(reason, maxLen = 72) {
  if (!reason) return "";
  const t = reason.trim();
  if (t.length <= maxLen) return t;
  return `${t.slice(0, maxLen - 1)}…`;
}

export const LANE_DEFAULT_VISIBLE = 2;
export const RELATIONSHIP_DEFAULT_VISIBLE = 3;
